export default function _footer() {
    const backToTopButton = document.querySelector(
        '.footer-component-back-to-top-button'
    );

    backToTopButton.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    });
}

_footer();
